import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import {
    Box, Button, Stack, Typography,
} from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const ROOT_SX = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: { xs: 2, md: 3 },
    py: { xs: 4, md: 6 },
};

const CONTENT_SX = {
    width: '100%',
    maxWidth: 560,
    textAlign: 'center',
};

const STATUS_CODE_SX = {
    fontFamily: theme => theme.typography.headlineL.fontFamily,
    fontWeight: 800,
    lineHeight: 1,
    fontSize: { xs: '5rem', md: '7.5rem' },
    letterSpacing: '-0.03em',
    color: 'primary.main',
};

const BACK_HOME_SX = {
    textTransform: 'none',
    borderRadius: 2,
    px: 3,
    py: 1.25,
    minHeight: 44,
    color: 'primary.contrastText',
    '&:hover, &:focus': {
        color: 'primary.contrastText',
    },
};

function NotFoundState({
    title, backHomeLabel, testId, backHomeTestId, statusCode, description, search,
}) {
    return (
        <Box sx={ROOT_SX} data-testid={testId}>
            <Stack spacing={3} alignItems="center" sx={CONTENT_SX}>
                <Stack spacing={1} alignItems="center">
                    {statusCode ? (
                        <Typography
                            component="div"
                            aria-hidden="true"
                            sx={STATUS_CODE_SX}
                            data-testid={`${testId}-code`}
                        >
                            {statusCode}
                        </Typography>
                    ) : null}
                    <Typography variant="headlineL" component="h1">{title}</Typography>
                </Stack>
                {search ? (
                    <Box sx={{ width: '100%' }} data-testid={`${testId}-search`}>
                        {search}
                    </Box>
                ) : null}
                {description ? (
                    <Typography variant="bodyM" sx={{ color: 'text.secondary' }}>
                        {description}
                    </Typography>
                ) : null}
                <Button
                    variant="contained"
                    component={RouterLink}
                    to="/"
                    startIcon={<HomeOutlinedIcon />}
                    sx={BACK_HOME_SX}
                    data-testid={backHomeTestId}
                >
                    {backHomeLabel}
                </Button>
            </Stack>
        </Box>
    );
}

NotFoundState.propTypes = {
    title: PropTypes.string.isRequired,
    backHomeLabel: PropTypes.string.isRequired,
    testId: PropTypes.string.isRequired,
    backHomeTestId: PropTypes.string.isRequired,
    statusCode: PropTypes.string,
    description: PropTypes.string,
    search: PropTypes.node,
};

export default NotFoundState;
